<script setup>
import { onMounted, onUnmounted, ref, nextTick} from "vue";
import { useSettingsStore } from "@/stores/storeSettings";
import { useScrollStore } from "@/stores/storeScroll";
import { useRequestsStore } from "@/stores/storeRequests";
import { useFieldsStore } from "@/stores/storeFieldData";
import { useGameHistory } from "@/composables/useGameHistory";
import { useRoute, useRouter } from "vue-router";
import { initYandexMetrika, trackPixel } from "@/utils/metrika";
import TheHeader from "@/components/sections/TheHeader.vue";
import TheHeaderTelegram from "@/components/sections/TheHeaderTelegram.vue";
import TheFooter from "@/components/sections/TheFooter.vue";
import TheModals from "@/components/blocks/TheModals.vue";
import TheStubPage from "@/pages/TheStubPage.vue";
import BaseCookies from "@/components/blocks/BaseCookies.vue";
import TheEventAnnouncement from "@/components/blocks/TheEventAnnouncement.vue";
import TheLeaves from "@/components/blocks/TheLeaves.vue";
import TheLine from "@/components/sections/TheLine.vue";
import { useModals } from "@/composables/useModals";
import { SERVICE_OUTAGE } from "@/utils/serviceOutage";

const FORCE_SHOW_PROMO_REGISTRATION_REQUIRED = false;
// попап о сбое облачного провайдера: показывается один раз за сессию браузера
const SERVICE_NOTICE_SHOWN_KEY = "service_notice_shown";

const storeSettings = useSettingsStore();
const storeScroll = useScrollStore();
const storeRequests = useRequestsStore();
const storeField = useFieldsStore();
const route = useRoute();

const { initTimer } = useGameHistory();

const isStubPage = import.meta.env.VITE_SHOW_STUB === "true";

const isShowMobileMenu = ref(false);
const { openModal } = useModals();

onMounted(async () => {

	await nextTick();

	await storeSettings.mainSettings();
	// await initTimer();
	if (storeRequests.isAuthenticated) {
		await storeRequests.userInfo();

		storeField.updateFields("firstName", "disabledBtn", true);
		storeField.updateFields("lastName", "disabledBtn", true);
		storeField.updateFields("phone", "disabledBtn", true);
		storeField.updateFields("email", "disabledBtn", true);
	}


	window.addEventListener("scroll", storeScroll.onScroll);
	window.addEventListener("resize", storeSettings.updateWidthWindow);
	storeScroll.updatePadding();
	storeSettings.updateWidthWindow();
	if (document.readyState === "complete") {
		storeSettings.pageLoaded();
	} else {
		window.onload = () => storeSettings.pageLoaded();
	}

	// initYandexMetrika();
	trackPixel('VIEW', 'tracking');

	if (FORCE_SHOW_PROMO_REGISTRATION_REQUIRED) {
		openModal("promoCodeRegistrationRequired", { size: "w400" });
	}

	showServiceNotice();
});

const showServiceNotice = () => {
	if (!SERVICE_OUTAGE || isStubPage || storeSettings.isTelegramPage) {
		return;
	}

	try {
		if (sessionStorage.getItem(SERVICE_NOTICE_SHOWN_KEY)) {
			return;
		}
		sessionStorage.setItem(SERVICE_NOTICE_SHOWN_KEY, "1");
	} catch {
		// без sessionStorage попап покажется при каждом заходе
	}

	openModal("serviceNotice", { size: "w830" });
};
onUnmounted(() => {
	window.removeEventListener("scroll", storeScroll.onScroll);
	storeScroll.updatePadding()
});
</script>

<template>
<div v-ios-scrollbar="{ selectors: ['.list-scrollbar'] }">

	<div v-if="!isStubPage"  :class="['wrapper']" id="header">
		<TheHeaderTelegram  v-if="storeSettings.isTelegramPage"/>
		<TheHeader @mobile-menu-show="isShowMobileMenu = !isShowMobileMenu" v-else/>
		<main :class="['main', { 'mobile-menu-open': isShowMobileMenu }]" >
			<RouterView />
		</main>
		<TheLine />
		<TheFooter />
		<TheLeaves v-if="!storeSettings.isTelegramPage" />
	</div>
	<TheStubPage v-else />
	<BaseCookies v-if="!isStubPage" />
	<TheEventAnnouncement v-if="!isStubPage && !storeSettings.isTelegramPage" />
	<TheModals v-if="!isStubPage" />
</div>
</template>

<style type="scss" scoped></style>
